import * as yup from "yup";
const FileSize = 5000000;
const allowedFormats = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];
const maxFileSize = 5 * 1024 * 1024; // 5 MB
const maxFiles = 3;

export const TaskFormConfig = [
  {
    id: 0,
    name: "",
    heading: "",
    fields: [
      {
        name: "incident_type_id",
        label: "taskformlabels.incident",
        type: "select",
        defaultselect: true,
        placeholder: "Select Category",
        options: [],
      },

      {
        name: "task_name",
        label: "taskformlabels.overview",
        type: "input",
        mandatory: "true",
      },
      {
        name: "assign_to_id",
        label: "taskformlabels.assignto",
        type: "select",
        defaultselect: true,
        placeholder: "Select Role",
        options: [],
      },

      {
        name: "description",
        label: "taskformlabels.summary",
        type: "text_area",
        mandatory: true
      },

      {
        name: "task_media_file",
        label: "taskformlabels.attachments",
        type: "multi_file_upload_For_Task",
      },
    ],
  },
];

export const sopTableData = [
  {
    title: "New Task",
    incidentname: "Daily Operations",
    status: "Not Started",
    assignedby: "Odhisha Test",
    duedate: "30/07/2025, 10:00 AM",
    assignedto: "Odhisha Test",
    dateassigned: "30/07/2023, 12:00 AM",
    actions: "actions",
  },
  {
    title: "New Task",
    incidentname: "Daily Operations",
    status: "Not Started",
    assignedby: "Odhisha Test",
    duedate: "30/07/2025, 10:00 AM",
    assignedto: "Odhisha Test",
    dateassigned: "12/08/2023, 12:00 AM",
    actions: "actions",
  },
  {
    title: "New Task",
    incidentname: "Daily Operations",
    status: "Not Started",
    assignedby: "Odhisha Test",
    duedate: "30/07/2025, 10:00 AM",
    assignedto: "Odhisha Test",
    dateassigned: "12/07/2023, 12:00 AM",
    actions: "actions",
  },
];

export const viewtaskcolumnsForExportView = [
  { label: "SOP Name", key: "task_name" },
  { label: "Incident Type", key: "incident_type" },
  // { label: "Priority", key: "task_priority" },
  // { label: "Task Status", key: "task_status" },
  { label: "Assigned To", key: "role_name" },
  { label: "Created On", key: "created_on" },
  { label: "Updated By", key: "updated_by" },
  { label: "Task Type", key: "task_type" },
  // { label: "Assigned To", key: "role_name" },
];

export const SopInstancedata = [
  { label: "ID", key: "id" },
  { label: "Instance Name", key: "name" },
  { label: "Sop Name", key: "sop" },
  { label: "Incident Name", key: "incident" },
  { label: "Status", key: "status" },
  { label: "Created By", key: "created_by" },
  { label: "Created On", key: "created_on" },
  // { label: "Task Type", key: "task_type" },
  // { label: "Assigned To", key: "role_name" },
];

export const SoPFormConfig = [
  {
    id: 0,
    name: "",
    heading: "",
    fields: [
      {
        name: "incidentId",
        label: "sopformlabels.incidentcategory",
        type: "select",
        defaultselect: true,
        placeholder: "Select Category",
        options: [],
      },
      {
        name: "severity",
        label: "sopformlabels.severity",
        type: "select",
        defaultselect: true,
        placeholder: "Select Severity",
        options: [
          { value: "Level 1 – Minor", label: "Level 1 – Minor" },
          { value: "Level 2 – Moderate", label: "Level 2 – Moderate" },
          { value: "Level 3 – Major", label: "Level 3 – Major" },
          { value: "Level 4 – Critical", label: "Level 4 – Critical" },
        ],
      },
      {
        name: "sop_task",
        label: "sopformlabels.task",
        type: "multi_select",
        mandatory: "true",
        options: [],
      },
      {
        name: "name",
        label: "sopformlabels.name",
        type: "input",
        mandatory: "true",
      },
      {
        name: "description",
        label: "sopformlabels.description",
        type: "text_area",
        mandatory: "true",
      },
    ],
  },
];

export const sopformschema = [
  yup.object({
    name: yup.string().required("Please provide the SOP name"),
    description: yup
      .string()
      .nullable()
      .test(
        "not-empty",
        "Please provide the SOP Description",
        value => value === null || value.trim().length > 0
      )
      .max(250, "SOP Description must be at most 250 characters"),
    severity: yup.string().required("Please select the severity"),
    sop_task: yup
      .array()
      .required("Please select SOP task type")
      .min(1, "Pick at least 1")
      // .max(10, `You can assign a maximum of 10 tasks.`)
      .of(
        yup.object().shape({
          value: yup.string().required(),
        })
      ),
  }),
];


export const taskmanagementschema = [
  yup.object({
    task_name: yup.string().required("Please enter the task name"),
    description: yup
      .string()
      .nullable()
      .test(
        "not-empty",
        "Please provide the Task Description",
        value => value === null || value.trim().length > 0
      )
      .max(250, "Description must be at most 250 characters"),
    task_media_file: yup
      .array()
      .test(
        "maxFiles",
        `You can upload up to ${maxFiles} files max.`,
        function (value) {
          const { existingFiles = [] } = this.options.context || {};
          const totalFiles = (value?.length || 0) + (existingFiles?.length || 0);
          return totalFiles <= maxFiles;
        }
      )
      .of(
        yup
          .mixed()
          .test(
            "fileFormat",
            "Invalid file format. Allowed file formats are jpeg, png, gif, webp, pdf, doc, and docx.",
            (value) => value && allowedFormats.includes(value.type)
          )
          .test(
            "fileSize",
            "Each file must be 5MB or smaller.",
            (value) => value && value.size <= maxFileSize
          )
      )
      .nullable(),

  }),
];
